import { accountTypes } from '../types';
import { getUserData, saveUserData, setNewPassword, saveSubscribe } from '../services/account';
import { showMessage } from './message';

export const getData = () => async (dispatch) => {
    dispatch({ type: accountTypes.USER_DATA_REQUEST });

    return getUserData(1)
        .then((user) => {
            setTimeout(() => {
                dispatch({ type: accountTypes.USER_DATA_SUCCESS, user });
            }, 1000);
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: accountTypes.USER_DATA_ERROR, error });
        });
};

export const saveData = ({ user, formId, form, target }) => async (dispatch) => {
    dispatch({ type: accountTypes.USER_DATA_CHANGE_REQUEST, user, form });

    return saveUserData(user)
        .then((response) => {
            const { user } = response;

            dispatch({ type: accountTypes.USER_DATA_CHANGE_SUCCESS, user });
            dispatch(showMessage({ textId: formId, target: target || 'user' }));
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: accountTypes.USER_DATA_CHANGE_ERROR, error });
        });
};

export const saveSubscribeData = ({ subscribe, formId, form }) => async (dispatch) => {
    dispatch({ type: accountTypes.USER_SUBSCRIPTIONS_CHANGE_REQUEST, subscribe });

    return saveSubscribe(subscribe)
        .then(() => {
            dispatch({ type: accountTypes.USER_SUBSCRIPTIONS_CHANGE_SUCCESS });

            dispatch(showMessage({ textId: formId }));
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: accountTypes.USER_SUBSCRIPTIONS_CHANGE_ERROR, error });
        });
};

export const setPassword = ({ passwords, formId, form, target }) => async (dispatch) => {
    dispatch({ type: accountTypes.USER_PASSWORD_CHANGE_REQUEST, passwords, form });

    return setNewPassword(passwords)
        .then((response) => {
            dispatch({ type: accountTypes.USER_PASSWORD_CHANGE_SUCCESS, ...response });
            dispatch(showMessage({ textId: formId, target: target || 'password' }));
        })
        .catch((error) => {
            console.error(error);
            dispatch({ type: accountTypes.USER_PASSWORD_CHANGE_ERROR, error });
        });
};

export const clearData = async (dispatch) => dispatch({ type: accountTypes.CLEAR });
